import _ from 'lodash'

const isChecked = (state) => state.isAuthenticated !== undefined
const isAuthenticated = (state) => _.get(state, 'isAuthenticated')
const profile = (state) => _.get(state, 'data')
const authErrors = (state) => _.get(state, 'errors')
const isLoading = (state) => _.get(state, 'loading')
const UserLogInCategories = (state) => _.get(state, 'UserLogInCategories')
const userRegistrationCategories = (state) => _.get(state, 'userRegistrationCategories')
const mapRegisterToken = (state) => _.get(state, 'mapRegisterToken')
const isLoadingCategories = (state) => _.get(state, 'isLoadingCategories')
const settings = (state) => _.get(state, 'settings')
const settingsError = (state) => _.get(state, 'settingsError')
const settingsLoading = (state) => _.get(state, 'settingsLoading')
const profileSection = (state) => _.get(state, 'profileSection')
const profileSectionError = (state) => _.get(state, 'profileSectionError')
const profileSectionLoading = (state) => _.get(state, 'profileSectionLoading')
const changePasswordError = (state) => _.get(state, 'changePasswordError')
const logOutError = (state) => _.get(state, 'logOutError')

export default {
	isChecked,
	isAuthenticated,
	profile,
	authErrors,
	isLoading,
	UserLogInCategories,
	userRegistrationCategories,
	mapRegisterToken,
	isLoadingCategories,
	settings,
	settingsError,
	settingsLoading,
	profileSection,
	profileSectionError,
	profileSectionLoading,
	changePasswordError,
	logOutError,
}
